(function(window1) {
    const showModalButtons = document.querySelectorAll('.showModal');
    const webinarModal = document.getElementById('webinarModal');
    const content = webinarModal.querySelector('.content');
    const closeIcon = content.querySelector('.content > svg');
    const form = content.querySelector('form');
    const okButton = content.querySelector('.ok');
    const button = form.querySelector('.mainButton');
    const retryButton = content.querySelector('.retryButton');
    const inputs = form.querySelectorAll('input:not([type=hidden]');
    const api = 'https://nn.int.uxfb.dev/webhook/uxfb/add-lead-webinar';
    const urlParams = getAllQueryParams();
    const webinarDate = '2025-12-10';
    const YM_ID = 49633516;
    const validationRules = {
        name: /.+/g,
        position: /.+/g,
        project: /.+/g,
        phone: /.+/g,
        email: /.*@.*\..*/g
    };
    let timeout;
    function getAllQueryParams() {
        const urlParams = new URLSearchParams(window1.location.search);
        const params = {};
        for (const [key, value] of urlParams.entries())params[key] = value;
        return params;
    }
    showModalButtons.forEach((item)=>{
        item.onclick = (e)=>{
            e.preventDefault();
            webinarModal.style.display = 'flex';
            ym(YM_ID, 'reachGoal', document.location.host === 'uxfeedback.ru' ? 'webinar_form_view' : 'test_webinar_form_view');
        };
    });
    content.onmousedown = (e)=>{
        e.stopPropagation();
    };
    [
        okButton,
        webinarModal,
        closeIcon
    ].forEach((item)=>{
        item.onmousedown = ()=>{
            clearTimeout(timeout);
            content.classList.remove('success', 'failed');
            webinarModal.style.display = 'none';
            window1.location.hash = '';
            history.replaceState(null, null, ' ');
            form.reset();
            button.textContent = "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F";
            retryButton.textContent = "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437";
            button.removeAttribute('disabled');
            retryButton.removeAttribute('disabled');
        };
    });
    const isEmailValid = (email, rule)=>{
        return !!email.match(rule);
    };
    const isInputValid = (input, isEmail)=>{
        const rule = validationRules[input.name];
        return isEmail ? isEmailValid(input.value, rule) : input.value.match(rule);
    };
    const validateForm = ()=>{
        let isFormValid = [];
        inputs.forEach((item)=>{
            const isValid = isInputValid(item, item.name === 'email');
            if (isValid) isFormValid.push(true);
            else isFormValid.push(false);
        });
        return isFormValid;
    };
    const updateInputsClasses = ()=>{
        let isFormValid = [];
        inputs.forEach((item)=>{
            const isEmail = item.name === 'email';
            const isValid = isInputValid(item, isEmail);
            const isEmailFilled = isEmail && item.value.length > 0;
            const inputWrapper = item.parentElement.parentElement;
            if (isValid) {
                inputWrapper.classList.remove('invalid');
                isFormValid.push(true);
            } else {
                button.classList.add('invalid');
                inputWrapper.classList.add('invalid');
                isFormValid.push(false);
            }
            if (isEmailFilled) inputWrapper.classList.add('filled');
            else inputWrapper.classList.remove('filled');
        });
        const isAllInputsFilled = isFormValid.filter((status)=>!status).length === 1 && form.querySelector('.email.invalid.filled');
        if (!isAllInputsFilled) form.classList.add('invalid');
    };
    [
        button,
        retryButton
    ].forEach((item)=>item.onclick = (e)=>{
            e.preventDefault();
            let ycid = null;
            const formData = [
                ...new FormData(form).entries()
            ];
            const url = new URL(document.location.href);
            const ubtcuid = document.cookie.split('; ').find((row)=>row.startsWith('_ubtcuid'))?.split('=')[1];
            const domainUserId = window1.Snowplow?.getTrackerCf().getDomainUserId();
            ym(49633516, 'getClientID', (clientID)=>{
                ycid = clientID;
            });
            const dataObject = formData.reduce((acc, [key, val])=>({
                    ...acc,
                    [key]: val
                }), {
                urlUtm: url.href,
                ...urlParams,
                webinarDate: webinarDate,
                ubtcuid,
                domainUserId,
                ycid
            });
            if (dataObject.phone?.[0] !== '@') dataObject.phone = `@${dataObject.phone}`;
            if (validateForm().includes(false)) {
                updateInputsClasses();
                return;
            }
            item.textContent = "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C...";
            item.setAttribute('disabled', true);
            Object.keys(dataObject).forEach((key)=>{
                dataObject[key] = dataObject[key]?.replaceAll('>', '&#62;').replaceAll('<', '&#60;').replaceAll('&', '&#38;').replaceAll(/eval/gi, '&#101;&#118;&#97;&#108;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
            });
            fetch(api, {
                method: 'post',
                body: JSON.stringify(dataObject),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then((respose)=>{
                if (respose.status !== 200) throw respose;
                content.classList.remove('failed');
                content.classList.add('success');
                timeout = setTimeout(()=>{
                    content.classList.remove('success');
                    webinarModal.style.display = 'none';
                    button.textContent = "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F";
                    retryButton.textContent = "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437";
                    item.removeAttribute('disabled');
                    form.reset();
                }, 5000);
                ym(YM_ID, 'reachGoal', document.location.host === 'uxfeedback.ru' ? 'webinar_form_send' : 'test_webinar_form_send');
            }).catch(()=>{
                content.classList.add('failed');
                item.textContent = "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437";
                item.removeAttribute('disabled');
            });
        });
    inputs.forEach((input)=>{
        const inputWrapper = input.parentElement.parentElement;
        input.onkeyup = ()=>{
            if (!button.classList.contains('invalid')) return;
            const inputsValidationStatus = validateForm();
            const isAllInputsValid = !inputsValidationStatus.includes(false);
            const isAllInputsFilled = isAllInputsValid || inputsValidationStatus.filter((status)=>!status).length === 1 && form.querySelector('.email.invalid.filled');
            inputWrapper.classList.remove('invalid', 'filled');
            form.classList.remove('invalid');
            form.classList.add('half');
            if (isAllInputsFilled) form.classList.remove('half');
            if (isAllInputsValid) button.classList.remove('invalid');
            else updateInputsClasses();
        };
    });
})(window);

//# sourceMappingURL=webinarModal.eb60fc9e.js.map
